/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['../objectUtils', 'services/trafficModelId', 'security'], function(utils, trafficModelId, security) {
    var DEFAULT_REFRESH_RATE = 30000;
    return {
        add: function(options, onTrafficUpdateCallback) {
            var refreshRate = DEFAULT_REFRESH_RATE;

            if (utils.isNotNull(options)) {
                if (options._noRefresher) {
                    //This property ensures that the refresher doesn't start, it is used by trafficWithIncidentsLayer
                    //which has it's own timers and we don't want sub-layers to start its own timers
                    return undefined;
                } else if (options.noRefresh) {
                    onTrafficUpdateCallback();
                    return undefined;
                }
                //this ensures that minimal refresh time is 30 seconds
                refreshRate = options.refresh >= DEFAULT_REFRESH_RATE && isFinite(options.refresh) ?
                    options.refresh :
                    DEFAULT_REFRESH_RATE;
            }
            onTrafficUpdateCallback();
            return setInterval(onTrafficUpdateCallback, refreshRate);
        },
        remove: function(id) {
            clearInterval(id);
        },
        addRefresherWithModelId: function(options, trafficModelIdCallback, context) {
            var effectiveOptions = options ? options : context.options;
            var trafficModelIdService = trafficModelId({key: security.getKey('services/traffic')});
            return this.add(effectiveOptions, function() {
                trafficModelIdService.go().then(function(trafficModelId) {
                    trafficModelIdCallback.call(context, trafficModelId);
                });
            });
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/trafficRefresher.js